(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-quantity-selector"] && !Shopify.designMode) return;
  try {
    
class ProductQuantitySelector extends HTMLElement {
  constructor() {
    super();
    this.radios = this.querySelectorAll('.quantity-radio');
    this.productForm = document.querySelector('product-form');
    this.variantIdInput = this.productForm ? this.productForm.querySelector('input[name="id"]') : null;

    if (this.radios.length > 0 && this.variantIdInput) {
      this.addEventListeners();
      this.setInitialActiveState();
    } else {
        console.warn('ProductQuantitySelector: Missing radios or product form variant input.');
    }
  }

  addEventListeners() {
    this.radios.forEach(radio => {
      radio.addEventListener('change', this.onRadioChange.bind(this));
    });

    // Listen for external variant changes (e.g., if another variant selector exists)
    if (this.variantIdInput) {
        this.productForm.addEventListener('change', this.onExternalVariantChange.bind(this));
    }
  }

  setInitialActiveState() {
    const initialVariantId = this.variantIdInput ? parseInt(this.variantIdInput.value) : null;
    if (initialVariantId) {
      this.radios.forEach(radio => {
        if (parseInt(radio.value) === initialVariantId) {
          radio.checked = true;
          this.setActiveBox(radio);
        }
      });
    }
  }

  onRadioChange(event) {
    const selectedVariantId = event.target.value;
    this.setActiveBox(event.target);

    if (this.variantIdInput && selectedVariantId) {
      this.variantIdInput.value = selectedVariantId;
      // Trigger change event on the product-form element itself
      // This is how Dawn's ProductForm JS usually detects changes
      this.productForm.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  onExternalVariantChange() {
    // When Dawn's core product form changes the variant (e.g., dropdown is used),
    // update our custom radio buttons to reflect that.
    const currentVariantId = parseInt(this.variantIdInput.value);
    this.radios.forEach(radio => {
      if (parseInt(radio.value) === currentVariantId) {
        radio.checked = true;
        this.setActiveBox(radio);
      } else {
        radio.closest('.quantity-option-box').classList.remove('active');
      }
    });
  }

  setActiveBox(selectedRadio) {
    this.querySelectorAll('.quantity-option-box').forEach(box => {
      box.classList.remove('active');
    });
    selectedRadio.closest('.quantity-option-box').classList.add('active');
  }
}

customElements.define('product-quantity-selector', ProductQuantitySelector);

  } catch(e) { console.error(e); }
})();
})();
